// =========================================
// Step by Step
// Desktop (lg+): Swiper disabled → CSS grid (3×2, equal-height cards).
// Mobile/tablet: 1-row slider with prev/next nav.
// Swiper comes from the shared swiper-core bundle (window.Swiper).
// Figma: 329:6567 (desktop) / 329:8743 (mobile)
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.Swiper;
    const { Navigation } = window.SwiperModules || {};
    if (!Swiper) return;

    const wraps = document.querySelectorAll('[data-step-slider]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
        const el = wrap.querySelector('.swiper');
        if (!el) return;

        const nextEl = wrap.querySelector('[data-step-next]');
        const prevEl = wrap.querySelector('[data-step-prev]');

        new Swiper(el, {
            modules: Navigation ? [Navigation] : [],
            slidesPerView: 1.15,
            spaceBetween: 16,
            grabCursor: true,
            navigation: { nextEl, prevEl },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                // Desktop: turn Swiper off and let CSS grid take over (below),
                // which gives a clean 3×2 layout with equal-height cards.
                992: {
                    enabled: false,
                },
            },
        });
    });
});
